import { dateFormatter, planDetails, capitalize } from "./summaryUtils";

/**
 * Transform subscriptions data for table display
 */
export const transformSubscriptionsData = (subscriptions) => {
  if (!subscriptions || !Array.isArray(subscriptions)) {
    return [];
  }

  return subscriptions
    .filter((sub) => sub !== null)
    .map((sub) => ({
      id: sub.id,
      userName: sub.userName,
      userEmail: sub.userEmail,
      vip:
        sub.transactionId === "" &&
        !sub.coachId &&
        !sub.productId.includes("enterprise") &&
        !sub?.bootcampUser
          ? "Yes"
          : "No",
      staffCoach: sub.coachId ? "Yes" : "No",
      bootcampUser: sub?.bootcampUser ? "Yes" : "No",
      hasACoach: sub.hasACoach ? (sub.hasACoach ? "Yes" : "No") : "No",
      platform: sub.platform,
      plan: planDetails(sub.productId),
      autoRenewal: sub.autoRenewal,
      startDate: sub.startDate,
      lastUpdated: sub.lastUpdated,
      endDate: sub.endDate,
    }));
};

/**
 * Transform canceled subscriptions data for table display
 */
export const transformCanceledSubscriptionsData = (allCanceledUsers) => {
  if (!allCanceledUsers || !Array.isArray(allCanceledUsers)) {
    return [];
  }

  return allCanceledUsers
    .filter((sub) => sub !== null)
    .map((sub) => ({
      id: sub.id,
      userName: sub.userName,
      userEmail: sub.userEmail,
      vip:
        sub.transactionId === "" &&
        !sub.coachId &&
        !sub.productId.includes("enterprise") &&
        !sub?.bootcampUser
          ? "Yes"
          : "No",
      platform: sub.platform,
      plan: planDetails(sub.productId),
      autoRenewal: sub.autoRenewal,
      startDate: dateFormatter(sub.startDate),
      lastUpdated: dateFormatter(sub.lastUpdated),
      endDate: dateFormatter(sub.endDate),
    }));
};

/**
 * Transform invites data for table display
 */
export const transformInvitesData = (invites) => {
  if (!invites || !Array.isArray(invites)) {
    return [];
  }

  return invites
    .filter((inv) => inv !== null)
    .map((inv) => ({
      id: inv.id,
      invitee: inv.invitee,
      inviteeName: inv.inviteeName,
      sender: inv.senderName,
      role: inv.role,
      status: inv.status,
      createdDate: dateFormatter(inv.createdAt),
      expiredDate: dateFormatter(inv.expiredIn),
    }));
};

/**
 * Transform trial subscriptions data for table display
 */
export const transformTrialSubsData = (trialSubs) => {
  if (!trialSubs || !Array.isArray(trialSubs)) {
    return [];
  }

  return trialSubs
    .filter((sub) => sub !== null)
    .map((sub) => ({
      id: sub.id,
      userName: sub.userName,
      userEmail: sub.userEmail,
      platform: sub.platform,
      students: sub.students,
      sessions: sub.sessions,
      issues: sub.issues,
      plan: planDetails(sub.productId),
      status: sub.status ? sub.status : "canceled",
      startDate: sub.startDate,
      lastUpdated: sub.lastUpdated,
      endDate: sub.endDate,
    }));
};

/**
 * Transform NY campaign users data for table display
 */
export const transformNYCampaignData = (nyCampaignUsers) => {
  if (!nyCampaignUsers || !Array.isArray(nyCampaignUsers)) {
    return [];
  }

  return nyCampaignUsers
    .filter((sub) => sub !== null)
    .map((sub) => ({
      id: sub.id,
      userName: sub.firstName + " " + sub.lastName,
      email: sub.email,
      paid: sub.subscriptionType.includes("student_lite") ? "Yes" : "No",
      sessions: sub.sessionIds ? sub.sessionIds.length : 0,
      typicalMiss: sub.typicalMiss
        ? sub.typicalMiss.toString().replaceAll(",", ", ")
        : "",
      shotTrajectory: sub.shotTrajectory ? sub.shotTrajectory : "",
      date: dateFormatter(sub.userCreated),
    }));
};

/**
 * Transform collection counts data for table display
 */
export const transformCollCountsData = (collCounts) => {
  if (!collCounts || !Array.isArray(collCounts)) {
    return [];
  }

  return collCounts
    .filter((inv) => inv !== null)
    .map((inv) => ({
      id: inv.id,
      collection: capitalize(inv.id),
      total: inv.total,
      lastUpdated: dateFormatter(inv.lastUpdated),
    }));
};

